module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/gallery/gallery9-246ca3c3afc9a52bcfacd21d6e9e2a6a.jpg";